<template>
    <div class="mimglive_warp">
        <div :class="['all-loading tc',!isShowLoading ? 'animated zoomOut':'']" v-show='isShowLoading'>
            <img class="loading-logo-img" :src="require('@/common/images/mliveimgs/loading-logo.png')" alt="">
            <div class="progress-bar orange shine ">
                <span class="w100 load-progress"></span>
            </div>
            <div class="loading-btm col-blue">资鯨提供技术支持</div>
        </div>
        <!--全屏启动广告-->
        <v-touch v-on:swipeup="swiperTop" class="full-banner" @click="isShowFullBanner = false" :class="!isShowFullBanner ? 'fadeInUp' : ''" v-show="isShowFullBanner">
          <span @click="swiperTop" class="cutdown pa ft12">跳过 {{cutDown}}s</span>
          <img class="full-banner-img" :src="subjectMsg.posterurl">
          <i @click="swiperTop" class="go-index shakes pa el-icon-d-arrow-right icon"></i>
        </v-touch>
        <div class="m-live-cont">
          <!--banner-->
          <div class="banner">
            <img class="banner-img" :src="subjectMsg.coverurl">
            <div class="see">
              <i class="el-icon-view icon ft14"></i>
              {{subjectMsg.viewcount}}
            </div>
          </div>
          <!--主标题-->
          <div class="big-title tc">{{subjectMsg.title}}</div>
          <div class="ft12">
            <span class="col-999 ml10 lh40 mr20">{{subjectMsg.livebegintime}}</span>
            <span class="col-blue2">{{subjectMsg.statusname}}</span>
            <span class="fr lh40 mr10 col-333" @click="isShowContent = !isShowContent">
              活动简介
              <i
                v-bind:class="[!isShowContent ? 'el-icon-arrow-down middle':'el-icon-arrow-up','ft16']"
              ></i>
            </span>
            <div
              class="ins-content animated fadeInUp clear col-333"
              v-show="isShowContent"
            >{{subjectMsg.content}}</div>
          </div>
          <!--主体-->
          <div class="bg-f2 pr">
            <!--菜单-->
            <ul
              :class="isTop ? 'menu-top' : ''"
              class="menu-ul col-999 tc ft13 bgfff"
              v-show="menuList.length"
            >
              <li
                :class="itm.ischeck ? 'active':'col-999' "
                v-for="(itm,index) in menuList"
                @click="checkMenu(itm,index)"
                :key="index"
              >
                <a
                  :class="itm.ischeck ? 'active':'col-999' "
                  :href="itm.columnurl || 'javascript:void(0)'"
                  @click='false'
                >{{itm.columnname}}</a>
              </li>
            </ul>

            <!--循环产生各自的div-->
            <template v-for="(menuitem,index) in menuList">
              <div v-show="menuitem.innerid===menuId" :key="menuitem.innerid" >
                <!--图文直播-->
                <template v-if="menuitem.columntype===1">
                  <div class="detail-cont animated fadeInUp" v-for="(itm,idx) in menuitem.contentlist" :key="itm.innerid">
                    <span class="time pa col-fff ft12">{{itm.datetime}}</span>
                    <div
                      :class="[itm.isLike ? 'col-blue2':'col-999'] "
                      class="like pa"
                      @click="addLike(itm,idx,index)"
                    >
                      <img
                        v-show="itm.isLike"
                        class="iblock like-icon"
                        src="@/common/images/mliveimgs/index_zan02_icon_selected@2x.png"
                        alt="点赞"
                      >
                      <img
                        v-show="!itm.isLike"
                        class="iblock like-icon"
                        src="@/common/images/mliveimgs/index_zan02_icon_default@2x.png"
                        alt="点赞"
                      >
                      <span>{{itm.praisecount>1000 ? '1000+': itm.praisecount}}</span>
                    </div>
                      <div v-viewer="{ url: 'large',loading: true,title: 'alt',loop: true,toolbar:false,navbar:false,title:false, transition: false}">
                        <div
                          class="detail-btm"
                          v-html="itm.content"
                        ></div>
                        <!-- <div
                          class="detail-btm"
                          :class="itm.imgNum===0 ? 'img0': ''"
                          v-if="itm.imgNum===0"
                          v-html="itm.content"
                        ></div>
                        <div
                          class="detail-btm"
                          :class="itm.imgNum===1 ? 'img1': ''"
                          v-if="itm.imgNum===1"
                          v-html="itm.content"
                        ></div>
                        <div
                          class="detail-btm"
                          :class="itm.imgNum===2 ? 'img2': ''"
                          v-if="itm.imgNum===2"
                          v-html="itm.content"
                        ></div>
                        <div
                          class="detail-btm"
                          :class="itm.imgNum>2 ? 'img3': ''"
                          v-if="itm.imgNum>2"
                          v-html="itm.content"
                        ></div> -->
                      </div>
                  </div>
                </template>

                <!--海报-->
                <template v-if="menuitem.columntype===2">
                  <!-- <div class="adword-cont animated fadeInUp"> -->
                  <div class="adword-cont">
                      <!-- <viewer :images="menuitem.contentlist"> -->
                          <div class="adword_img_box" v-viewer="{ url: 'large',loading: true,title: 'alt',loop: true,toolbar:false,navbar:false,title:false, transition: false}">
                            <img v-for="(itm) in menuitem.contentlist" v-lazy="itm.posterurl_s" :key="itm.innerid" class="adword"
                              :large="itm.posterurl" :alt="itm.id" />
                          </div>
                      <!-- </viewer> -->
                  </div>
                </template>

                <!--图文信息-->
                <template v-if="menuitem.columntype===3">
                  <div
                    class="detail-cont animated fadeInUp"
                    v-for="(itm) in menuitem.contentlist"
                    :key="itm.innerid"
                  >
                    <div
                      class="detail-btm type-3"
                      :class="itm.imgNum===0 ? 'img0': ''"
                      v-html="itm.content"
                    ></div>
                  </div>
                </template>

                <!--直播未开始或该栏目下没有详情-->
                <div class="tc bgfff" v-show="!menuitem.contentlist || !menuitem.contentlist.length">
                  <img class="no-live-img" src="@/common/images/mliveimgs/no-live.png" alt>
                  <div class="ft14 col-999 pb20">{{subjectMsg.status === 0 ? '直播还未开始':'暂无数据'}}</div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!--预约、联系我们、到顶按钮-->
        <div class="call-fixed">
          <div class="fixed-logo tc" v-if="hostdetailatturl"><img class='fixed-logo-img' :src="hostdetailatturl" alt="Logo"></div>
          <img @click="showPoster" src="@/common/images/mliveimgs/icon_poster@2x.png" alt="生成海报">
          <img @click="goIndex" src="@/common/images/mliveimgs/home-icon@2x.png" alt="回到首页">
          <img @click="goTop" src="@/common/images/mliveimgs/up-icon@2x.png" alt="到顶部">
        </div>
    </div>
</template>
<script>
import {getWXSDKSetting} from 'common/js/wxSDKSetting'
import {mapGetters} from 'vuex'
import $ from 'jquery'
import {getLiveInfo, getColumnData, uploadLike, getPendingInfo, getEndInfo, getLiveInfoByPage} from 'api/mLiveApi'
// import { getCode } from "@/api/login";
import Vue from 'vue'
import {Lazyload, Toast} from 'vant';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Lazyload);
export default {
  data() {
    return {
        id: "", // 直播id
        isTop: false,
        // _isTop: false, //是否菜单在顶部
        // get isTop() {
        //     return this._isTop;
        // },
        // set isTop(value) {
        //     this._isTop=value;
        // },
        subjectMsg: {
            posterurl: "", //全屏banner
            coverurl: "", //banner图
            title: "", //主标题
            content: "", //描述
            statusname: "", //主题状态
            livebegintime: "", //开始时间
            viewcount: 0, //浏览量
            status: "" // 0未开始  10进行中   30已结束 100已删除
        },
        cutDown: 5, //倒计时
        isFirstTime: 1, //0不是第一次，1是第一次
        isShowContent: false, //是否显示活动介绍
        menuId: "", //菜单id
        menuIdx: 0, //菜单下标id
        menuList: [], //菜单列表
        contentList: [], //图文详情列表
        adwordList: [], //海报列表
        detailType: 1, //1图文直播,2海报,3图文信息
        reload: "", //0已开始 除开0以外每十秒刷一次
        mediaNewsList: [], //媒体播报列表
        lastId: 0, //进行中的详情内容列表中的id,上一次的最大内容id
        isShowFullBanner: false, //是否展示全屏banner
        isReoadPage: false, //是否刷新页面
        reloadWindow: 1, //进行中，reloadWindow为0则刷新页面
        scrollTop: 0,
        isShowContactUs: false, //是否显示联系我们弹框
        isShowLive: false, //是否显示预约直播
        isShowLiveSuccss: false, //是否显示预约成功
        code_url: "", //验证码图片
        isLoadingSave: false, //是否加载保存用户预约按钮
        // isShowLoading:false,//是否显示加载数据层
        isShowLoading:true,//是否显示加载数据层
        hostdetailatturl:'',//主办方logo
        defalutLogo:require('@/common/images/mliveimgs/fixed-logo.png'),
        userLiveInfo: {
            innerid: this.id, //直播id
            name: "", //姓名
            phone: "", //电话
            reqinfo: "", //需求
            company: "", //公司
            code: "", //验证码
            clienttype: "2" //移动端2,pc1
        },
        qrCode: "", //验证码
        timer: null, //定时器      
        refeshtimes: 30000, //刷新时间
        clickTime:0,//点击后延迟时间
        pagesizetext: 10, //图文每页记录
        pagesizeposter: 16, //海报每页记录
    };
  },
  created() {
    if(!this.domainInfo.isMobile){
        this.$router.push({
            name: 'LiveingDetails',
            query: {'innerid': this.$route.query.liveid}
        })
    }
    this.id = this.$route.query.liveid
    // let flag = navigator.userAgent.match(
    //   /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    // );
    // if (!flag) {
    //   var _url = window.location.origin + "/w/live?innerid=" + this.id;
    //   window.location = _url;
    // }
    // this.findLiveInfo()
    this.findColumnList()
  },
  mounted() {
    console.log(Viewer);
    
    document.addEventListener("scroll", this.handleScroll);
    this.$nextTick(function () {
      var viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    })
  },
  filters: {
    dateForDay(str) {
      return str.substring(0, 10);
    }
  },
  methods: {
    // 生成海报
    showPoster() {
      this.$router.push({
        name:'ImgLivePoster',
        query:{liveid: this.id}
      })
    },
    // 回到首页
    goIndex () {
      this.$router.push({
          name:'MLiveIndex',
          query:{}
      })
    },
    //去顶部
    goTop() {
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    //根据菜单的itm，index以及相关属性获取栏目内容数据
    getMenuContent(itm, idx,isinterval,localrefreshtimes){
      let _that=this
      let param = {
        innerid: itm.innerid
      };
      //**********未开始
      if (this.subjectMsg.status === 0) {
        getPendingInfo({
            data: Object.assign({}, param),
            success: data => {
                this.contentList = data.data.content;
                this.menuList[idx].contentlist = this.contentList;
                this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                this.reload = data.data.reload;
            },
            error: data => {
                // console.log('error：', data)
                this.$toast.fail(data.msg)
            }
        })
      }
      else if (this.subjectMsg.status === 10) {
        param.latestid = this.menuList[idx].latestid;
        getLiveInfo({
            data: Object.assign({}, param),
            success: data => {
                if (data.data.reloadwindow === 1) {
                  this.$router.go(0);
                  return;
                }
                if (itm.columntype === 1 || itm.columntype === 2) {
                  // this.$previewRefresh();
                  if (data.data.content.length > 0) {
                      this.contentList = data.data.content;
                      this.getImg();
                      if (!this.menuList[idx].contentlist) {
                        this.menuList[idx].contentlist = this.contentList;
                      } 
                      else {
                        for (var i = this.contentList.length - 1; i >= 0; i--) {
                          this.menuList[idx].contentlist.splice(0,0,this.contentList[i]);
                        }
                      }
                      this.menuList[idx].latestid = this.contentList[0].id;                  
                      this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                      this.reload = data.data.reload;
                  } else {
                    this.contentList = [];
                  }
                }
                else{
                  // this.$previewRefresh();
                  this.contentList = data.data.content;
                  this.getImg();
                  this.menuList[idx].contentlist = this.contentList;
                  this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                  this.reload = data.data.reload;
                }
            },
            error: data => {
                this.$toast.fail(data.msg)
            }
        })
      }
      else if (this.subjectMsg.status === 30) {
        param.pagesize = itm.pageSize;
        if (itm.columntype === 3) {
          param.currentpage = 1;
        }
        else{
          param.currentpage = itm.currentpage + 1;
        }
        getEndInfo({
            data: Object.assign({}, param),
            success: data => {
                if (itm.columntype === 3) {
                  this.contentList = data.data.content;
                  this.menuList[idx].contentlist = this.contentList;
                  this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                  this.reload = data.data.reload;
                  this.menuList[idx].isloadingmoredata = 0;
                }
                else{
                  // this.$previewRefresh();
                  if (data.data.content.length > 0) {
                    this.contentList = data.data.content;
                    this.getImg();
                    if (!this.menuList[idx].contentlist) {
                      this.menuList[idx].contentlist = this.contentList;
                    } else {
                      for (var i = 0; i < this.contentList.length; i++) {
                        this.menuList[idx].contentlist.push(this.contentList[i]);
                      }
                    }
                    if (data.data.pageinfo.pagecount <=this.menuList[idx].currentpage) {
                      this.menuList[idx].loadmore = 0;
                    } else {
                      this.menuList[idx].loadmore = 1;
                      this.menuList[idx].currentpage =this.menuList[idx].currentpage + 1;
                    }
                  } else {
                    this.menuList[idx].loadmore = 0;
                  }
                  this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                  this.menuList[idx].isloadingmoredata = 0;
                }
            },
            error: data => {
                // console.log('error：', data)
                this.$toast.fail(data.msg)
            }
        })
      }
      if(isinterval==1){
        this.timer = setInterval(function() {
              _that.getMenuContent(itm, idx,0,0);
            }, localrefreshtimes);
      }
    },
    //获取直播中的状态上拉分页数据
    getMenuContentByPullOnMore(itm, idx){
        // let _that=this
        let param = {
            innerid: itm.innerid,
            curminid:itm.minid,
            datacount:itm.pageSize
        };
        getLiveInfoByPage({
            data: Object.assign({}, param),
            success: data => {
                if (data.data.reloadwindow === 1) {
                    this.$router.go(0);
                    return;
                }
                // this.$previewRefresh();
                if (data.data.content.length > 0) {
                    this.contentList = data.data.content;
                    this.getImg();
                    if (!this.menuList[idx].contentlist) {
                        this.menuList[idx].contentlist = this.contentList;
                    } 
                    else {
                        for (var i = 0; i < this.contentList.length; i++) {
                            this.menuList[idx].contentlist.push(this.contentList[i]);
                        }
                    }
                    if (data.data.content.length <this.menuList[idx].pagesize) {
                        this.menuList[idx].loadmore = 0;
                    } else {
                        this.menuList[idx].loadmore = 1;
                    }
                    this.menuList[idx].minid=data.data.content[data.data.content.length-1].id
                } else {
                    this.menuList[idx].loadmore = 0;
                    this.contentList = [];
                }
                this.menuList.splice(idx, 1, this.menuList[idx]); //替换掉原对象
                this.menuList[idx].isloadingmoredata = 0;
            },
            error: data => {
                // console.log('error：', data)
                this.$toast.fail(data.msg)
            }
        })
    },
    // 查询移动端图文直播详情
    findColumnList() {
        if (!this.id || this.id === "undefined") {
          Toast.fail('没有直播Id~')
          this.isShowLoading = false
          return false
        }

        this.isShowLoading = true
        var params = {
            innerid: this.id
        }
        let that = this
        getColumnData({
            data: Object.assign({}, params),
            success: data => {
                let datas = data.data
                this.subjectMsg = {
                  posterurl: datas.posterurl,
                  coverurl: datas.coverurl,
                  title: datas.subject,
                  content: datas.content,
                  statusname: datas.statusname,
                  livebegintime: datas.livebegintime,
                  viewcount: datas.viewcount,
                  status: datas.status
                }
                this.mediaNewsList = datas.medialist; // 查询所有的媒体报道 无分页
                this.hostdetailatturl = datas.hostdetailatturl
                let list = datas.columnlist
                list.map(m => {
                  m.ischeck = false;
                  if (m.columntype === 1 || m.columntype === 3) {
                    m.pageSize = that.pagesizetext;
                  } else if (m.columntype === 2) {
                    m.pageSize = that.pagesizeposter;
                  } else {
                    m.pageSize = 10;
                  }
                  m.currentpage = 1;//默认加载数据，改成1
                  m.loadmore = 1; //是否还可以加载更多
                  m.isloadingmoredata = 0; //当前是否是正在获取更多数据
                  if(m.contentlist && m.contentlist.length>0){
                      m.latestid = m.contentlist[0].id
                      m.minid=m.contentlist[m.contentlist.length-1].id
                      that.contentList = m.contentlist;
                      if (m.columntype === 1){
                          // that.$previewRefresh();
                          // that.getImg();
                          m.contentlist = that.contentList
                      }
                  }
                  else{
                      m.latestid=0
                      m.minid=0
                      that.contentList = []
                  }                    
                })
                list[0].ischeck = true
                this.menuList = list;
                this.menuId = this.menuList[0].innerid;
                this.checkMenu(list[0], 0, false);
                // if(Number(localStorage.getItem('isFirstTime'))) return
                // localStorage.setItem('isFirstTime', 1)
                if (this.subjectMsg.posterurl !== "") {
                  //是否考虑对每个id单独设置
                  let localBannerTime = localStorage.getItem("bannerTime"),
                    id = localStorage.getItem("innerid");
                  if (
                    (id && +new Date() > localBannerTime) ||
                    !id ||
                    id !== this.id
                  ) {
                    this.isShowFullBanner = true;
                    this.setBannerTime();
                    this.cutDownChange();
                  }
                }
                document.title = this.subjectMsg.title
                this.isShowLoading = false // 关闭加载中样式
                // 微信分享
                // this.getMPJSAPIData();
                if (this._isWixin()) {
                    // Toast('微信分享')
                    // let link = `http://ke.capwhale.com/courseView?cid=${this.$route.query.cid}`
                    let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?liveid=' + this.$route.query.liveid
                    getWXSDKSetting({
                        title: this.subjectMsg.title,
                        desc: this.subjectMsg.content,
                        link: link,
                        imgUrl: this.subjectMsg.coverurl,
                    })
                }
            },
            error: data => {
                this.isShowLoading = false
                this.$toast.fail(data.msg)
            }
        })
    },
    _isWixin() {
        let ua = window.navigator.userAgent.toLowerCase()
        if (/micromessenger/.test(ua)) {
            return true
        } else {
            return false
        }
    },
    setBannerTime() {
      localStorage.setItem("innerid", this.id);
      localStorage.setItem("bannerTime", +new Date() + 1000 * 60 * 10);
    },
    cutDownChange() {
      if (this.subjectMsg.posterurl && this.cutDown > 0) {
        var timer = setInterval(() => {
          if (this.cutDown > 0) {
            this.cutDown--;
          } else {
            clearInterval(timer);
            this.cutDown = 0;
            this.isShowFullBanner = false;
          }
        }, 1000);
      }
    },
    //菜单选中 同时记录数据
    //处理逻辑：根据不同的状态显示不同的值，同时将已经取得的数据保存在页面缓存中
    checkMenu(itm, idx, isClick = true) {
      console.log(isClick);
      if(itm.columnnamenum==11 || itm.columnnamenum==12){
        return
      }
      this.isShowContent = false
      this.detailType = itm.columnnamenum;
      this.menuList.map(m => {
        m.ischeck = false;
      });
      this.menuList[idx].ischeck = true;
      if (this.timer) {
        clearInterval(this.timer);
      }
      let _that = this;
      //**********未开始
      if (this.subjectMsg.status === 0) {
        if (this.detailType === 1) {
          //显示直播未进行
          this.menuId = itm.innerid; //当前选择的栏目id
        } else if (this.detailType === 2 || this.detailType === 3) {
          this.menuId = itm.innerid; //当前选择的栏目id
          //这些可能提前发布，一次性获取数据 先判断本地是否有数据
          if (
            !this.menuList[idx].contentlist ||
            this.menuList[idx].contentlist.length <= 0
          ) {
            //延迟执行
            setTimeout(function(){
              _that.getMenuContent(itm,idx,0,0)
            }, _that.clickTime);
          }
        }
      } else if (this.subjectMsg.status === 10) {
        //***********进行中
        this.menuId = itm.innerid; //当前选择的栏目id
        //默认有数据，直接定时获取即可        
        if(this.detailType==1 || this.detailType==2){
            this.timer = setInterval(function() {
                _that.getMenuContent(itm,idx,0,0)
            }, _that.refeshtimes);
        }
        return
      } else if (this.subjectMsg.status === 30) {
        this.menuId = itm.innerid; //当前选择的栏目id
        //**********已结束 数据放缓存,根据分页信息确定上拉分页
        // console.log('this.menuList[idx].isloadingmoredata:'+this.menuList[idx].isloadingmoredata)
        if (
          !this.menuList[idx].contentlist ||
          this.menuList[idx].contentlist.length <= 0 ||
          this.menuList[idx].isloadingmoredata == 1
        ) {
           //第一次获取 延迟执行
            setTimeout(function(){
              _that.getMenuContent(itm,idx,0,0)
            }, _that.clickTime);
        }
      }
    },
    //滚动条操作
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop >= 350) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
      this.loadMore();
    },
    //加载更多
    loadMore() {
      let scrollTop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      let isBtm =
        document.documentElement.scrollHeight -
        scrollTop -
        document.documentElement.clientHeight;
      if (isBtm <= 10) {
        let _idx;
        let that = this;
        if(this.subjectMsg.status!=30 && this.subjectMsg.status!=10){
          return
        }
        
        //加载更多
        this.menuList.map((m, idx) => {
          if (m.innerid == that.menuId) {            
            // console.log('isloadingmoredata:'+m.isloadingmoredata+';loadMore:'+m.loadmore)
            if (
              m.isloadingmoredata == 0 &&
              m.loadmore == 1 &&
              (m.columntype == 1 || m.columntype == 2)
            ) {
              _idx = idx;
              m.isloadingmoredata = 1;
              if(this.subjectMsg.status==10){
                  this.getMenuContentByPullOnMore(m,_idx)
              }
              else{
                  this.getMenuContent(m,_idx,0,0)
              }
            }
          }
        });
      }
    },
    //抓取img,为图片排版样式做准备
    getImg() {
      if (this.detailType === 2) return
      // let str = "",
      //   imgReg = /<img.*?(?:>|\/>)/gi,
      //   srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i,
      //   nullP = '<p><br/></p>';
        
      // console.log(str)
      //   this.contentList.map((m, idx) => {
      //     console.log(idx)
          
      //     m.isLike = false;
      //     m.content = m.content.replace(new RegExp(nullP,'g'),"");//替换掉空标签
      //     m.imglist = m.content.match(imgReg) || [];
      //     m.imgNum = m.imglist.length;
      //     // if (m.imgNum) {
      //     //   m.content = m.content.replace(
      //     //     /\<( img |img )/g,
      //     //     "<img preview=" + m.innerid + " "
      //     //   );
      //     // }
      //   });
    },
    //点赞
    addLike(itm, idx, index) {
      let param = {
        innerid: itm.innerid,
        columninnerid: this.menuList.filter(m => m.ischeck)[0].innerid
      };
      uploadLike({
          data: Object.assign({}, param),
          success: data => {
              // this.setLoading(false)
              // console.log(data.data)
              this.menuList[index].contentlist[idx].isLike = true;
              this.menuList[index].contentlist[idx].praisecount = data.data.praisecount;
          },
          error: data => {
              // console.log('error：', data)
              this.$toast.fail(data.msg)
          }
      })
    },
    // 暂留此处
    findLiveInfo() {
        if (!this.id || this.id === "undefined") {
          Toast.fail('没有直播Id~')
          this.isShowLoading = false
          return false
        }

        this.isShowLoading = true
        var params = {
            innerid: this.id
        }
        getLiveInfo({
            data: Object.assign({}, params),
            success: data => {
                console.log(data.data)
                this.isShowLoading = false
                this.subjectMsg = data.data
                // $('html').scrollTop(0)
            },
            error: data => {
                this.isShowLoading = false
                this.$toast.fail(data.msg)
            }
        })
    },
    //滑动关闭闪屏
    swiperTop() {
      this.isShowFullBanner = false
      this.cutDown = 0
    },
  },
  watch: {
    reloadWindow: function() {
      if (this.reloadWindow === 0) {
        setInterval(() => {
          this.$router.go(0);
        }, 10000);
      }
    },
    id: function() {
      if (this.id === "") {
        this.$message({
          message: "没有直播Id~",
          type: "error"
        });
        return;
      }
    },
    isShowLive(){
        if (this.isShowLive) {
          $('#app').css({position: 'fixed'})
        } else{
          $('#app').css({position: 'relative'})
        }
    }
  },
  computed: {
      ...mapGetters([
          'user',
          'domainInfo'
      ])
  },
  destroyed() {
    clearInterval(this.timer)
  }
};
</script>

<style scoped lang="scss" type="text/scss">
@import "./minglive.css";
.mimglive_warp {
  min-height: 100vh;
}
.m-live-cont {
  // padding-bottom: 1rem;
  max-width: 100vw;
  margin: 0 auto;
}

a {
  text-decoration: none;
}

.block {
  display: block;
}

.col-blue2 {
  color: #1890ff;
}

.col-999 {
  color: #999;
}

.col-333 {
  color: #333;
}

.col-fff {
  color: #fff;
}
.pl30 {
  padding-left: 0.6rem;
}
.icon {
  width: 0.32rem;
  height: 0.32rem;
  margin-right: 0.06rem;
  vertical-align: middle;
}
.inp-icon {
  z-index: 26;
  top: 0.2rem;
  left: 0.1rem;
}
.inp-icon.need {
  top: 0.24rem !important;
}
.tc {
  text-align: center;
}

.ft12 {
  font-size: 0.24rem;
}

.ft14 {
  font-size: 0.28rem;
}

.ft16 {
  font-size: 0.32rem;
}

.mt20 {
  margin-top: 0.4rem;
}

.mb20 {
  margin-bottom: 0.4rem;
}

.pt50 {
  padding-top: 0.7rem;
}

.pb20 {
  padding-bottom: 0.4rem;
}

.mr10 {
  margin-right: 0.2rem;
}

.mr20 {
  margin-right: 0.4rem;
}

.bgfff {
  background: #fff;
}

.iblock {
  display: inline-block;
}

.pr {
  position: relative;
}

.pa {
  position: absolute;
}
.full-banner {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 23;
  background: rgba(0, 0, 0, 0.8);
  .cutdown {
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    width: 1rem;
    height: 0.5rem;
    line-height: 0.5rem;
    text-align: center;
    border-radius: 15%;
    right: 0.2rem;
    top: 0.2rem;
  }
  .full-banner-img {
    width: 100%;
    height: 100vh;
  }
  .go-index {
    font-size: 0.72rem;
    color: #fff;
    bottom: 0.8rem;
    left: 50%;
    margin-left: 0;
    transform: rotate(90deg);
  }
}

.banner {
  width: 100%;
  font-size: 0.24rem;
  color: #fff;
  position: relative;
  .banner-img {
    width: 100%;
    height: 4.2rem;
  }
  .see {
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
    text-shadow: 0 0 0.04rem #000;
  }
}

.big-title {
  color: #333;
  font-size: 0.36rem;
  width: calc(100% - 0.4rem);
  line-height: 0.54rem;
  padding: 0.2rem;
  font-family: PingFangSC-Medium, sans-serif;
  margin: 0 0 0.2rem 0;
  position: relative;
}
.big-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -0.2rem;
  width: 100%;
  height: 0.2rem;
  background: #f2f2f2;
}
.ins-content {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 0.26rem;
  color: #333;
  border-top: 0.02rem solid rgb(238, 238, 238);
  padding: 0.2rem;
  line-height: 0.42rem;
  text-align: justify;
  word-break: break-all;
}
.bg-f2 {
  background: #f2f2f2;
  padding: 0.2rem 0;
  height: auto;
  overflow-y: auto;
}

.menu-ul {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
  line-height: 0.8rem;
  font-family: PingFangSC-Medium, sans-serif;
  li {
    list-style: none;
    flex: 1;
  }
  li.active {
    background: #1890ff;
  }
  li.active a {
    color: #fff;
  }
}

.menu-top {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 22;
  width: 100%;
  background: #fff;
  box-shadow: -0.04rem 0 0.04rem #eee;
}

.adword-cont {
  width: calc(100% - 0.4rem);
  margin: 0.2rem;
}
.adword_img_box {
  display: flex;
  flex-wrap: wrap;
  .adword {
    width: calc(50% - 0.1rem);
    min-width: calc(50% - 0.1rem);
    height: 6.15rem;
    min-height: 6.15rem;
    margin-bottom: 0.2rem;
  }

  .adword:nth-child(2n) {
    margin-left: 0.2rem;
  }
}

.detail-cont {
  border-radius: 0.1rem;
  background: #fff;
  margin: 0.2rem 0.2rem 0 0.2rem;
  font-size: 0.28rem;
  font-family: "Arial" !important;
  line-height: 1.5em;
  padding: 0.2rem;
  height: auto;
  overflow-y: auto;
  word-break: break-all;
  text-align: justify;
  .time {
    width: 1.18rem;
    height: 0.4rem;
    left: 0;
    margin-top: -0.2rem;
    padding-left: 0.2rem;
    line-height: 0.4rem;
    background: url('../../../common/images/mliveimgs/feed02-icon@2x.png') no-repeat;
    background-size: contain;
  }
  .like {
    right: 0.4rem;
    // top: 0.25rem;
    line-height: 0.5rem;
    border: 0.02rem solid #eee;
    border-radius: 0.04rem;
    padding: 0 0.2rem;
    .like-icon {
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.06rem;
      margin-top: 0.04rem;
      vertical-align: text-top;
    }
  }
  .detail-btm {
    margin-top: 0.7rem;
  }

  .detail-btm.type-3 {
    margin-top: 0 !important;
  }
}

.yichen-img {
  max-width: 100%;
  margin: 0.2rem auto;
}

.no-live-img {
  display: block;
  width: 2.66rem;
  height: 3rem;
  margin: 0.2rem auto;
  padding: 0.4rem 0;
}
.more-img {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-flow: nowrap;
  img {
    width: 30%;
    justify-content: space-between;
    height: 2rem;
  }
}


.dialog-cont {
  width: calc(100vw - 1.2rem);
  max-width: calc(100vw - 1.2rem);
  margin: 0.6rem 0.4rem 0 0.4rem;
  padding: 0 0.2rem;
  border-radius: 0.2rem;
  z-index: 26;
  min-height: 5.2rem;
  background: #fff;
  position: fixed;
  bottom: 0.2rem;
  .logo-div {
    width: 1.2rem;
    height: 1.2rem;
    line-height: 1.2rem;
    margin-top: -0.6rem;
    background: #fff;
    padding: 0.2rem;
    border-radius: 50%;
    box-shadow: 0 0 0.1rem #ccc;
    position: absolute;
    left: 50%;
    margin-left: -0.8rem;
  }
  .dialog-logo {
    width: 0.8rem;
    height: 0.8rem;
    margin-top: 0.2rem;
  }
  .media-tit {
    color: #333;
    font-weight: bold;
    font-size: 0.36rem;
    margin: 1.4rem auto 0.4rem;
  }
  .list {
    max-height: 4.4rem;
    overflow-y: scroll;
    margin-bottom: 1rem;
  }
  .a-item {
    padding-bottom: 0.12rem;
    margin-bottom: 0.12rem;
    border-bottom: 0.02rem solid #eee;
  }
  .title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 0.52rem;
  }
  .btm-hide {
    position: absolute;
    bottom: 0;
    line-height: 0.6rem;
    background: #fff;
    text-align: center;
    padding: 0.2rem 0;
    width: calc(100% - 0.4rem);
  }
  .code-img {
    width: 3.4rem;
    height: 3.4rem;
    margin: 0.4rem auto;
  }
}

.dialog-cont.live-dailog {
     height: calc(100% - 1.6rem)!important;
//   max-height: none;
}
.masker {
  width: 100%;
  height: 100%;
  max-width: 100vw;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.4);
  z-index: 25;
  position: fixed;
  top: 0;
}

.call-fixed {
  position: fixed;
  bottom: 2rem;
  right: 0.2rem;
  width: 0.6rem;
  height: 2.1rem;
}
.fixed-logo{
  width: 0.56rem;
  height: 0.56rem;
  margin-bottom: 0.18rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 0.08rem #ccc;
}
.call-fixed img {
  width: 0.56rem;
  height: 0.56rem;
  margin-bottom: 0.1rem;
}
.fixed-logo-img{
  width: 0.36rem!important;
  height: 0.36rem!important;
  margin: 0.1rem 0 0 0!important;
}
.user-info-form {
  width: 90%;
  margin: 0 auto;
}

.my-small-inp {
  width: calc(100% - 3.4rem) !important;
}

.dialog-cont-success {
  border-radius: 0.16rem;
  .success-icon {
    margin-top: 1.5rem;
    margin-bottom: 0.4rem;
  }
  .success-text {
    height: 0.8rem;
    font-size: 0.6rem;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 0.8rem;
  }
  .success-footer {
    margin-top: 0.8rem;
    color: #666;
  }
  .phone {
    text-align: center;
    margin-top: 0.08rem;
    color: #666;
    span {
      color: #1464c8;
    }
  }
  .cancel-icon {
    position: absolute;
    right: 0;
    top: -0.8rem;
    cursor: pointer;
    img {
      width: 0.6rem;
      height: 0.6rem;
    }
  }
}
</style>

<style>
.detail-cont .detail-btm p {
  margin: 0 0 0.2rem 0 !important;
  font-family: PingFangSC-Medium, sans-serif!important;
  font-size: 0.26rem!important;
  color: #333!important;
}
.detail-cont .detail-btm p span{
  font-family: PingFangSC-Medium, sans-serif!important;
  font-size: 0.26rem!important;
}
.detail-cont .detail-btm p:last-child{
  /* display: none; */
}
.edit-color {
  color: #c4c7cf;
}

.detail-btm img {
  max-width: 100% !important;
  margin-bottom: 0.1rem;
}

.detail-btm.img1 img {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 auto !important;
}

.detail-btm.img2 img {
  width: calc(50% - 0.1rem) !important;
  height: 1.8rem !important;
}

.detail-btm.img2 img:nth-child(2n) {
  margin-left: 0.2rem !important;
}

.detail-btm.img3 img {
  width: calc(33.3% - 0.16rem) !important;
  margin-right: 0.16rem !important;
  height: 1.8rem !important;
}

.detail-btm.img2 img:nth-child(3n) {
  margin-right: 0 !important;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes shakes {
  0% {
    opacity: 1;
    zoom: 1;
  }
  50% {
    opacity: 0.8;
    zoom: 1.1;
  }
  100% {
    opacity: 1;
    zoom: 1;
  }
}

@keyframes shakes {
  0% {
    opacity: 1;
    zoom: 1;
  }
  50% {
    opacity: 0.8;
    zoom: 1.1;
  }
  100% {
    opacity: 1;
    zoom: 1;
  }
}
.user-info-form .el-input__inner,
.user-info-form .el-textarea__inner {
  padding-left: 0.54rem !important;
}
.user-info-form .el-textarea__inner{
    padding-top: 0.18rem !important;
}
.shakes {
  -webkit-animation: shakes 1s infinite;
  animation: shakes 1s infinite;
}

@-webkit-keyframes shakes {
  0% {
    opacity: 1;
    zoom: 1;
  }
  50% {
    opacity: 0.6;
    zoom: 1.2;
  }
  100% {
    opacity: 0.8;
    zoom: 1;
  }
}

@-webkit-keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 0.4rem, 0);
    transform: translate3d(0, 0.4rem, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 0.4rem, 0);
    transform: translate3d(0,0.4rem, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.my-textarea textarea {
  font-family: "Arial" !important;
  -webkit-appearance: none;
}

.my-textarea i {
  left: 0.2rem;
  top: 0.2rem;
}

.pr .el-form-item__content {
  display: flex;
}

.code-qr-img-m {
  width: 2.4rem;
  height: 0.76rem;
  right: 0.6rem;
  bottom: 0;
  /*margin-left: 0.2rem;*/
}

.code-qr-img-m img {
  width: 100%;
  height: 100%;
}
.order-btn.el-button{
    width: 100%;
    color: #fff;
    background: #409EFF;
    border-radius:0.08rem;
    border-width: 0;
    padding: 0.3rem 0.8rem;
}
.live-dailog-enter-active, .live-dailog-leave-active{
    transition: all 0.35s
}
.live-dailog-enter, .live-dailog-leave-to{
    transform: translate3d(0, 120%, 0)
}
.viewer-backdrop {
    background-color: rgba(0, 0, 0, 1);
}
</style>